import React, { useState, useEffect, useRef } from 'react';
import * as XLSX from "xlsx";
import { useConfig } from '../utils/ConfigContext';
import { createAxiosInstance } from '../utils/AxiosInstance';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import { set } from 'date-fns';

const MAIN_TABLE_HEADER_TOP = [
    { label: "#", rowSpan: 2 },
    { label: "Center Name", rowSpan: 2 },
    { label: "D1 Running", colSpan: 3 },
    { label: "New Bookings", colSpan: 3 },
    { label: "Total Run", colSpan: 3 },
    { label: "Scheduled To Complete", colSpan: 3 },
    { label: "Completed", colSpan: 3 },
    { label: "Pending To Complete", colSpan: 3 },
    { label: "Last Day Run", colSpan: 3 },
];

const MAIN_TABLE_HEADER_SECOND = [
    "SNB",
    "SDT",
    "SNB+SDT",
    "SNB",
    "SDT",
    "SNB+SDT",
    "SNB",
    "SDT",
    "SNB+SDT",
    "SNB",
    "SDT",
    "SNB+SDT",
    "SNB",
    "SDT",
    "SNB+SDT",
    "SNB",
    "SDT",
    "SNB+SDT",
    "SNB",
    "SDT",
    "SNB+SDT",
];

const flatColumns = [
    { label: "#", key: "#" },
    { label: "Center Name", key: "Center Name" },
    { label: "Date", key: "Date" },
    { label: "Total", key: "total_lead" },
    { label: "Converted", key: "converted_lead" },
    { label: "Appts.", key: "appointments" },
    { label: "SNB", key: "package_booked_snb" },
    { label: "SDT", key: "package_booked_sdt" },
    { label: "SNB+SDT", key: "package_booked_snb_sdt" },
    { label: "SNB", key: "package_completed_snb" },
    { label: "SDT", key: "package_completed_sdt" },
    { label: "SNB+SDT", key: "package_completed_snb_sdt" },
    { label: "SNB", key: "treatment_scheduled_snb" },
    { label: "SDT", key: "treatment_scheduled_sdt" },
    { label: "SNB", key: "treatment_completed_snb" },
    { label: "SDT", key: "treatment_completed_sdt" },
    { label: "Comp. Hrs.", key: "comperession_snb" },
    { label: "SNB", key: "machines_snb" },
    { label: "SDT", key: "machines_sdt" },
    { label: "SNB", key: "cui_snb" },
    { label: "SDT", key: "cui_sdt" },
];

const stateOrderMap = {
    "Uttarakhand": 0,
    "West Bengal": 1,
    "Maharashtra": 2,
    "Karnataka": 3,
    "Tamil Nadu": 4,
    "Madhya Pradesh": 5,
    "New Delhi": 6,
};

const CenterPackageReport = () => {
    const [openPanels, setOpenPanels] = useState({});
    const [stateReports, setStateReports] = useState([]); // [{ stateName, centers: [...], summary: { last_day, last_month, this_month, last_year } }]
    const [isLoading, setIsLoading] = useState(false);
    const { API_BASE_URL } = useConfig(); // ✅ from context
    const AxiosInstance = createAxiosInstance(API_BASE_URL);
    const [openedStatePanel, setOpenedStatePanel] = useState(false);
    const reportTableRef = useRef(null);
    const currentDate = new Date().toISOString().split("T")[0];

    const [modalData, setModalData] = useState(null);
    const [modalLoading, setModalLoading] = useState(false);
    const [dataCategory, setDataCategory] = useState("");
    const [isFullScreenModal, setIsFullScreenModal] = useState(false);
    const [leadModel, setLeadModel] = useState(false);
    const [appointmentModel, setAppointmentModel] = useState(false);
    const [patientModel, setPatientModel] = useState(false);
    const [patientModalHeader, setPatientModalHeader] = useState("");
    const [pdfDropdownOpen, setPdfDropdownOpen] = useState(false);
    const [stateSelectionModal, setStateSelectionModal] = useState(false);
    const [selectedStatesForPrint, setSelectedStatesForPrint] = useState({});
    const [centerData, setCenterData] = useState([]);
    const LeadStatusMap = {
        0: "New",
        1: "Scheduled",
        2: "Follow Up",
        3: "Converted",
        4: "Closed",
        5: "Transferred",
    };

    const firstHeaderRowStyle = {
        backgroundColor: "#009ed6",
        color: "white",
    };
    const firstHeaderRowSpanStyle = {
        backgroundColor: "#009ed6",
        color: "white",
    };
    const secondHeaderRowStyle = {
        backgroundColor: "#009ed6",
        color: "white",
    };


    const fetchCenters = async () => {
        try {
            setIsLoading(true);
            setStateReports([]);

            const response = await AxiosInstance.post('/centers/package_overview', { startDate: "2025-02-01", endDate: "2025-02-28" });
            const data = response.data?.data || [];
            setCenterData(data);


        } catch (error) {
            console.error('Error fetching centers / daily report:', error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchCenters();
    }, []);



    return (
        <>
            <div className="DailyReportTableTest pb-80">
                <div >
                    {isLoading ? (
                        <div className="text-center py-2">
                            Loading daily report state wise...
                        </div>
                    ) : (
                        <div className="btn-group d-flex justify-content-end position-relative">
                            <OverlayTrigger
                                placement="top"
                                delay={{ show: 250, hide: 400 }}
                                overlay={
                                    <Tooltip id="button-pdf">
                                        Print Pdf
                                    </Tooltip>
                                }
                            >
                                <div className=" cursor-pointer w-40-px h-40-px bg-neutral-200 rounded-circle d-flex justify-content-center align-items-center me-2 position-relative"
                                    onClick={() => setPdfDropdownOpen(!pdfDropdownOpen)} >
                                    <i className="ri-file-pdf-2-line"></i>

                                    {pdfDropdownOpen && (
                                        <div style={{
                                            position: 'absolute',
                                            top: '100%',
                                            right: 0,
                                            backgroundColor: 'white',
                                            border: '1px solid #ccc',
                                            borderRadius: '4px',
                                            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                                            zIndex: 1000,
                                            minWidth: '150px',
                                            marginTop: '5px'
                                        }}>
                                            <div
                                                style={{
                                                    padding: '10px 15px',
                                                    cursor: 'pointer',
                                                    borderBottom: '1px solid #eee',
                                                    fontSize: '12px'
                                                }}
                                                onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                                                onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                                                onClick={() => {
                                                    // generatePdf();
                                                    setPdfDropdownOpen(false);
                                                }}
                                            >
                                                Print Full Table
                                            </div>
                                            <div
                                                style={{
                                                    padding: '10px 15px',
                                                    cursor: 'pointer',
                                                    fontSize: '12px'
                                                }}
                                                onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                                                onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                                                onClick={() => {
                                                    setStateSelectionModal(true);
                                                    setPdfDropdownOpen(false);
                                                    // Reset selections
                                                    setSelectedStatesForPrint({});
                                                }}
                                            >
                                                Print Full States
                                            </div>
                                            <div
                                                style={{
                                                    padding: '10px 15px',
                                                    cursor: 'pointer',
                                                    fontSize: '12px'
                                                }}
                                                onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                                                onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                                                onClick={() => {
                                                    // generatePdf(null, true);
                                                    setPdfDropdownOpen(false);
                                                }}
                                            >
                                                Print Only States
                                            </div>
                                        </div>
                                    )}

                                </div>
                            </OverlayTrigger>
                            <OverlayTrigger
                                placement="top"
                                delay={{ show: 250, hide: 400 }}
                                overlay={
                                    <Tooltip id="button-excel">
                                        Download Excel
                                    </Tooltip>
                                }
                            >


                                <div className=" cursor-pointer w-40-px h-40-px bg-neutral-200 rounded-circle d-flex justify-content-center align-items-center me-2"
                                >
                                    <i className="ri-file-excel-2-line"></i>

                                </div>

                            </OverlayTrigger>

                        </div>

                    )}
                    <div className='' style={{ minHeight: "400px", maxHeight: "800px", overflowX: "auto", WebkitOverflowScrolling: "touch" }}>
                        <table
                            ref={reportTableRef}
                            className="table table-bordered border-2 table-hover text-center align-middle mb-0"
                            style={{ whiteSpace: "nowrap" }}
                        >

                            {/* ================= HEADER ================= */}
                            <thead className="table-primary text-light text-white text-center align-middle border-3 " style={{ position: "sticky", top: 0, zIndex: 3 }}>

                                {/* FIRST ROW */}
                                <tr>
                                    {MAIN_TABLE_HEADER_TOP.map((header, index) => (
                                        <th
                                            key={`header-top-${index}`}
                                            rowSpan={header.rowSpan}
                                            colSpan={header.colSpan}
                                            style={header.rowSpan ? firstHeaderRowSpanStyle : firstHeaderRowStyle}
                                        >
                                            {header.label}
                                        </th>
                                    ))}
                                </tr>

                                {/* SECOND ROW */}
                                <tr>
                                    {MAIN_TABLE_HEADER_SECOND.map((label, index) => (
                                        <th key={`header-second-${index}`} style={secondHeaderRowStyle}>
                                            {label}
                                        </th>
                                    ))}
                                </tr>
                            </thead>

                            {/* ================= BODY ================= */}
                            <tbody>
                                {centerData.length === 0 ? (
                                    <tr>
                                        <td colSpan={21} className="text-center py-4">  No data available for the selected date range.</td>
                                    </tr>
                                ) : (
                                    centerData.map((center, index) => (
                                        <tr key={`center-row-${index}`}>
                                            <td>{index + 1}</td>
                                            <td>{center.hm_name}</td>
                                           
                                            {Object.keys(center.opening_package).map((key) => (
                                                <React.Fragment key={`${center.hm_name}-opening-${key}`}>
                                                    <td>{center.opening_package[key]}</td>
                                                   
                                                </React.Fragment>
                                            ))}
                                             {Object.keys(center.added_package).map((key) => (
                                                <React.Fragment key={`${center.hm_name}-added-${key}`}>
                                                    <td>{center.added_package[key]}</td>
                                                </React.Fragment>
                                            ))}
                                            {Object.keys(center.total_run_package).map((key) => (
                                                <React.Fragment key={`${center.hm_name}-total-run-${key}`}>
                                                    <td>{center.total_run_package[key]}</td>
                                                </React.Fragment>
                                            ))}
                                            
                                            {Object.keys(center.schedule_to_complete_packages).map((key) => (
                                                <React.Fragment key={`${center.hm_name}-scheduled-to-complete-${key}`}>
                                                    <td>{center.schedule_to_complete_packages[key]}</td>
                                                </React.Fragment>
                                            ))}
                                            {Object.keys(center.completed_packages).map((key) => (
                                                <React.Fragment key={`${center.hm_name}-completed-${key}`}>
                                                    <td>{center.completed_packages[key]}</td>
                                                </React.Fragment>
                                            ))}
                                            {Object.keys(center.pending_to_complete_packages).map((key) => (
                                                <React.Fragment key={`${center.hm_name}-pending-to-complete-${key}`}>
                                                    <td>{center.pending_to_complete_packages[key]}</td>
                                                </React.Fragment>
                                            ))}
                                            {Object.keys(center.closing_package).map((key) => (
                                                <React.Fragment key={`${center.hm_name}-closing-${key}`}>
                                                    <td>{center.closing_package[key]}</td>
                                                    
                                                </React.Fragment>
                                            ))}
                                        </tr>
                                    ))
                                )}

                            </tbody>
                        </table>

                    </div>




                </div>
            </div>

        </>
    );
};

export default CenterPackageReport;
